import React, { FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'

import { Box } from '@/atoms/layout'
import { PublicH1 } from '@/atoms/typography'
import { Space } from '@/styles'

import LoginForm from './login-form'

const LoginPage: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <Box width={1}>
      <PublicH1 mb={Space.S32}>{t('login.form_title')}</PublicH1>
      <LoginForm />
    </Box>
  )
}

export default LoginPage
